export const API_BASE_URL = `${process.env.REACT_APP_TPDD_RISK_MANAGEMENT_API_ENDPOINT}api`